import useOrganizationContext from "hooks/useOrganizationContext";
import { useQuery } from "react-query";
import { getAllZones } from "./api";
import Zone from "models/zone";

export const useGetAllZones = ({ eventId, queryParams = {}, options = {} }) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	const defaultParams = {
		...queryParams
	};

	return useQuery(
		["zone-list", organizationId, eventId, defaultParams],
		() =>
			getAllZones({
				organizationId,
				eventId,
				params: defaultParams
			}).then(({ response }) => response.map(Zone.buildFromJSON)),
		{
			...options,
			enabled:
				(options?.enabled ?? true) &&
				Boolean(organizationId) &&
				Boolean(eventId)
		}
	);
};
